module.exports = __webpack_public_path__ + "static/media/nodata.c7c91f0c.png";